/*
*/

  (function() {
    'use strict';

    function navbarCommentsController($rootScope, $timeout, $attrs, underwritingNotesDataService) {
      var vm = this;

      vm.currentCommentsCount= parseInt($attrs.currentCommentsCount, 10);

      function updateCommentsCountText() {
        vm.commentsCountText = vm.currentCommentsCount > 0
          ? vm.currentCommentsCount + " Notifications"
          : "";
      }

      updateCommentsCountText();

      function refreshComments() {
        $timeout(function () {
          underwritingNotesDataService.getNewNotes().then(function (data) {
            vm.currentCommentsCount = data.length;
            updateCommentsCountText();
          });
        }, 2000);
      }

      $rootScope.$on('noteResolved', function (event, args) {
        refreshComments();
      });

      $rootScope.$on('noteSaved', function (event, args) {
        refreshComments();
      })
    }

    navbarCommentsController.$inject = ['$rootScope', '$timeout', '$attrs', 'underwritingNotesDataService'];

    angular.module('ecap.common').controller('navbarCommentsController', navbarCommentsController);
})();